export default {"src":"/_next/static/media/arr_downbold.24d00f6d.svg","height":10,"width":16,"blurWidth":0,"blurHeight":0};